export const getToken = ()=>{
    return sessionStorage.getItem('token')
}
export const getUserInfo =()=>{
    /**
     * example
     *
     * birthday: null
     * certNumber: null
     * certType: null
     * createTime: "2022-03-05T08:28:31.000+00:00"
     * departId: "2"
     * departName: "安全部"
     * duty: null
     * email: null
     * employmentResiden: null
     * experience: null
     * graduationSchool: null
     * health: null
     * highestDegree: null
     * highestEducation: null
     * id: "88c5e7d7e5e63bdadf09d2faa862f6f9"
     * ifCse: 0
     * jobNumber: "12345"
     * jobSituation: null
     * joinOwnunitDate: null
     * lastUpdateTime: null
     * locationMac: null
     * major: null
     * name: "我是测试"
     * nation: null
     * nativePlace: null
     * phone: null
     * photo: null
     * politicalOutlook: null
     * post: null
     * postId: "0be8e18c9acda3d44504febd0f52c7c4"
     * postName: "安全总监"
     * postalCode: null
     * registeredResiden: null
     * remarks: null
     * sex: 1
     * specialPerson: 0
     * staffType: "18852762932"
     * title: null
     * training: null
     * trainingRecords: null
     * workDate: null
     * workTelephone: null
     * workYears: null
     */
    return JSON.parse(sessionStorage.getItem('staff'))
}
